import React from "react";
import { Tag, Tooltip } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { EDI_DIRECTION_ICONS, EDI_MESSAGE_TYPE_COLORS } from "./constants";

export const EdiMessageTypeTag = ({ entry }) => {
  const { t } = useTranslation();
  const Icon = EDI_DIRECTION_ICONS[entry.direction];
  return (
    <Tooltip title={t(`edi_log_direction_${entry.direction}`)}>
      <Tag color={EDI_MESSAGE_TYPE_COLORS[entry.messageType]} icon={Icon && <Icon />}>
        {entry.messageType}
      </Tag>
    </Tooltip>
  );
};

export const EdiStatusTag = ({ status }) => {
  const { t } = useTranslation();
  return status === "error" ? (
    <Tag color="error" icon={<CloseCircleOutlined />}>
      {t("edi_log_status_error")}
    </Tag>
  ) : (
    <Tag color="success" icon={<CheckCircleOutlined />}>
      {t("edi_log_status_success")}
    </Tag>
  );
};
